
import Vue from 'vue';
import axios from "axios";
import store from '../Store/index';

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || process.env.apiUrl || '';
// axios.defaults.headers.common['test'] = 'totototo';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.response.use(
    response => {
        if (store.state.backendDown) {
            store.commit('setBackendDown', false);
        }
        return response;
    },
    error => {
        if (!error.response) {
            store.commit('setBackendDown', true);
        }
        return Promise.reject(error);
    }
);

let config = {
    // baseURL: process.env.VUE_APP_BASE_URL,
    //timeout: 60 * 1000, // Timeout
    //  withCredentials: true, // Check cross-site Access-Control
};


const _axios = axios.create(config);


_axios.interceptors.request.use(
    function(config) {
        // Do something before request is sent
        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function(response) {
        // Do something with response data
        return response;
    },
    function(error) {
        // Do something with response error
        return Promise.reject(error);
    }
);
// eslint-disable-next-line
Plugin.install = function(Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;